import React from 'react'
import styled from '@emotion/styled'
import { MultilineTruncatedText, theme } from '@mindfulchefuk/design-system'

const StyledMultiLine = styled(MultilineTruncatedText)`
  font-size: 28px;
  @media screen and (max-width: 640px) {
    font-size: 22px;
  }
`

export const RecipeModalTitle = ({ title }: { title: string }) => {
  return (
    <StyledMultiLine
      color={theme.colors.pepper}
      data-testid="recipe-modal-title"
      flexGrow={4}
      lines={3}
      marginRight={6}
      variant="heading-sm"
    >
      {title}
    </StyledMultiLine>
  )
}
